import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const TimeDisplay = ({ activeTracker, loading, white }) => {
  const [timeTrackerDisplay, setTimeTrackerDisplay] = useState(null)

  const isCurrentlyPaused = activeTracker?.pauses?.some(
    (pause) => !pause.pauseEnd
  )

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600)
    const minutes = Math.floor((time % 3600) / 60)
    const seconds = time % 60

    return [hours, minutes, seconds]
      .map((v) => (v < 10 ? '0' + v : v))
      .filter((v, i) => v !== '00' || i > 0)
      .join(':')
  }
  useEffect(() => {
    let interval = null

    if (activeTracker && !isCurrentlyPaused && !activeTracker.endTime) {
      interval = setInterval(() => {
        const now = new Date().getTime()
        const totalTime = Math.floor(
          (now - new Date(activeTracker.startTime).getTime()) / 1000
        )

        const completedPauses = activeTracker?.pauses?.filter(
          (pause) => pause.pauseEnd
        )
        const totalPauseTime = completedPauses.reduce((total, pause) => {
          return (
            total +
            Math.floor(
              (new Date(pause.pauseEnd).getTime() -
                new Date(pause.pauseStart).getTime()) /
                1000
            )
          )
        }, 0)

        const cumulativeTime = totalTime - totalPauseTime
        setTimeTrackerDisplay(cumulativeTime)
      }, 100)
    }

    if (isCurrentlyPaused && interval) {
      clearInterval(interval)
    }

    return () => clearInterval(interval)
  }, [activeTracker, isCurrentlyPaused])

  return (
    <Box minWidth={150} textAlign="center">
      <Typography
        variant="digital"
        fontSize="20px"
        color={white && 'whitesmoke'}
      >
        {loading || isCurrentlyPaused
          ? '--:--'
          : formatTime(timeTrackerDisplay)}
      </Typography>
    </Box>
  )
}

export default TimeDisplay
